import { render, staticRenderFns } from "./Parents.vue?vue&type=template&id=43949a84&scoped=true&"
import script from "./Parents.vue?vue&type=script&lang=ts&"
export * from "./Parents.vue?vue&type=script&lang=ts&"
import style0 from "./Parents.vue?vue&type=style&index=0&id=43949a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43949a84",
  null
  
)

export default component.exports